// extracted by css-extract-rspack-plugin
export default {"pageWrapper":"CandidateTaskForm_pageWrapper__LpPKX","description":"CandidateTaskForm_description__JvXP7"};